import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import clsx from 'clsx';

import CustomerInfo from "../../../pages/accessRights/customerInfo/customerInfo";
import CircleLoader from "../../../components/custom/circleLoader/circleLoader";
import SectionContent from "../../../components/sectionContent/sectionContent";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const AdminClientsInfoSection = () => {
  const { id } = useParams<{ id: string }>();
  const { clientContractsLength, customers } = useSelector(
    (state: any) => state.roles.customerList
  );
  const { regionRestriction } = useSelector((state: any) => state.roles.customerList);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

  const actualClientName =
    customers &&
    customers.find(
      (elem: {
        contracts: string[];
        customer: { id: number, name: string }
        email: string;
        password: string;
      }) => elem?.customer?.id === parseFloat(id as string)
    )?.customer?.name;

    return (
    <div className="App">
      <Sidebar />
      <SectionContent
        title={actualClientName && actualClientName}
        pageName="clientInfo"
        section="Клиенты"
      >
        <div className="content__main">
          <div className={clsx(
            isOpenSidebar &&
            "btns_active",
            !isOpenSidebar && "btns_close",
            'btns'
          )}>
            <Link to={`/accessRights/customers/info/${id}`} className="tab">
              <div className="buttons__btn --active">
                Контракты
                <div className="tab__reports_count">
                  {!clientContractsLength && clientContractsLength !== 0 ? (
                    <CircleLoader />
                  ) : (
                    clientContractsLength
                  )}
                </div>
              </div>
            </Link>
            <Link to={`/accessRights/customers/settings/${id}`} className="tab">
              <div className="buttons__btn">Настройки</div>
            </Link>
            {regionRestriction && <Link to={`/accessRights/customers/regions/${id}`} className="tab">
              <div className="buttons__btn">Регионы</div>
            </Link>}
          </div>
          <CustomerInfo />
        </div>
      </SectionContent>
    </div>
  );
};

export default AdminClientsInfoSection;
